export default "__VITE_ASSET__Csj1$AJC__"